/* globals mApp */
/*
 Created by luis henriques on 07/08/2017.

 Core script to handle the entire theme and core functions
*/
import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import PerfectScrollbar from 'perfect-scrollbar';
import axios from 'axios';
import ImageInput from '../commonComponents/forms/ImageInput';
import i18n from './i18n';
import Notifications from './notifications';
import Request from './request';
import RenderService from './render';
import SocketClient from './socketClient';
import FormValidator from './formValidation';
import { handleImageUpload, uuid } from './utilityFunctions';

function handleError(err) {
  Notifications.showErrorFromRequest(err, '');
}

export default (() => {
  const connectModuleSidebar = {};
  let chatPrivateEnabled = true;
  let chatGroupsEnabled = true;
  let directSellingServiceActive = false;
  let activeChatGroup;
  let _csrf = null;
  let userId = null;
  let searchUsersValue = null;
  let searchPrivateChatValue = null;
  let searchChatGroupValue = null;
  let userItemHeight = 0;
  let privateChatItemHeight = 0;
  let totalUserList = 0;
  let userList = [];
  let totalPrivateChatList = 0;
  let privateChatsList = [];
  let totalMessageList = 0;
  let messages = [];
  let isFetchingMessages = false;
  let chatMessagesListScroll = null;
  let userListScroll = null;
  let privateChatListScroll = null;
  let chatGroupListScroll = null;
  let imageState = null;
  let selectedUserType = null;
  let orgLanguages = [];
  let tenant = {};
  let organization = {};
  let userTypes = [];
  let usersCanChooseTheirType = false;

  // region Side Bar Connect
  connectModuleSidebar.onUserTypeChange = () => {
    const userType = $('#userTypeFilter').val();
    selectedUserType = userType === 'all' ? null : userType;
    connectModuleSidebar.reloadUserList();
  };
  const getUser = () =>
    new Promise((resolve, reject) => {
      axios
        .get(`/api/user/${userId}`, {
          headers: {
            'Accept-Version': '1.0.0',
            'X-Gamification-API': 'Organization',
          },
        })
        .then(({ data: response }) => {
          resolve(response.data);
        })
        .catch(err => {
          console.log(err);
          reject(err);
        });
    });

  const onImageChange = image => {
    imageState = image;
  };

  const setChatMessageRead = messageId => {
    if (connectModuleSidebar.isScrollOnBottom('#chatMessagesWrapper')) {
      SocketClient.setMessageRead(messageId, () => {
        $(`#${messageId}`).attr('data-read', true);
      });
    }
  };

  const renderChatMessage = (chatGroup, message) => {
    let template = '/chat/adapters/';
    switch (message.type) {
      case 'users':
        template += 'chat_message_list_item_user_list.ejs';
        break;
      case 'image':
        template += 'chat_message_list_item_image.ejs';
        break;
      case 'video':
        template += 'chat_message_list_item_video.ejs';
        break;
      case 'file':
        template += 'chat_message_list_item_file.ejs';
        break;
      case 'joined':
      case 'left':
        template += 'chat_message_list_item_presence.ejs';
        break;
      case 'trophy':
        template += 'chat_message_list_item_trophy.ejs';
        break;
      case 'rating':
        template += 'chat_message_list_item_rating.ejs';
        break;
      case 'message':
      default:
        template += 'chat_message_list_item.ejs';
        break;
    }
    return RenderService.EJS(template, { chatGroup, message, ownerId: userId });
  };

  const getGroupBetweenUsers = user =>
    new Promise((resolve, reject) =>
      new Request(_csrf)
        .post('/api/chat/group', { users: [user._id] }, true, true)
        .done(result => {
          resolve(result.data);
        })
        .fail(err => {
          reject(err);
        }),
    );

  const fetchNextMessages = () =>
    new Promise(resolve => {
      isFetchingMessages = true;
      new Request()
        .get(
          `/chat-group/${activeChatGroup._id}/messages/table/list?index=${messages.length}`,
          null,
          true,
        )
        .done(result => {
          const newMessages = result.data;
          messages = messages.concat(newMessages);
          for (let i = 0; i < newMessages.length; i += 1) {
            const message = newMessages[i];
            $('#chatMessagesContent').prepend(
              renderChatMessage(activeChatGroup, message),
            );
            if (!message.read) {
              setChatMessageRead(message._id);
            }
          }

          isFetchingMessages = false;
          mApp.unblock('#chatMessageSideBar');
          resolve(result);
        })
        .fail(err => {
          isFetchingMessages = false;
          console.error(err);
          mApp.unblock('#chatMessageSideBar');
        });
    });
  const getUserChat = user => {
    isFetchingMessages = true;
    $('#chatMessageSideBar').removeClass('is-hidden');
    $('#connectModuleSideBar').addClass('is-hidden');
    $('#chatMessagesContent').html('');
    mApp.block('#chatMessageSideBar', {});

    getGroupBetweenUsers(user)
      .then(chatGroup => {
        activeChatGroup = chatGroup;
        connectModuleSidebar.reloadPrivateChatList();

        totalMessageList = 0;
        messages = [];
        SocketClient.joinChatGroup(chatGroup._id);

        fetchNextMessages().then(result => {
          totalMessageList = result.total;
          $('#chatMessageText').focus();
          setTimeout(() => {
            if (chatMessagesListScroll) {
              chatMessagesListScroll.update();
            }
            connectModuleSidebar.moveChatScroll();
          }, 300);
        });
      })
      .catch(err => {
        console.error(err);
        isFetchingMessages = false;
        mApp.unblock('#chatMessageSideBar');
        const { error } = err.responseJSON;
        Notifications.showNotificationError(i18n.__('error'), i18n.__(error));
      });
  };

  const getChatMessagesByUser = user => {
    $(`#${user._id}`).click(evt => {
      evt.preventDefault();
      getUserChat(user);
    });
  };

  const getGroupChat = chatGroup => {
    $('#chatMessageSideBar').removeClass('is-hidden');
    $('#connectModuleSideBar').addClass('is-hidden');

    if (
      chatGroup.type === 'group' &&
      !chatGroup.team &&
      chatGroup.owner &&
      chatGroup.owner._id === userId
    ) {
      $('.page-quick-sidebar-edit').show();
    } else {
      $('.page-quick-sidebar-edit').hide();
    }

    activeChatGroup = chatGroup;

    $('#chatMessagesContent').html('');
    totalMessageList = 0;
    messages = [];
    mApp.block('#chatMessageSideBar', {});
    SocketClient.joinChatGroup(chatGroup._id);

    fetchNextMessages().then(result => {
      totalMessageList = result.total;
      $('#chatMessageText').focus();
      setTimeout(() => {
        if (chatMessagesListScroll) {
          chatMessagesListScroll.update();
        }
        connectModuleSidebar.moveChatScroll();
      }, 300);
    });
  };

  const getChatMessageByChatGroup = chatGroup => {
    $(`#${chatGroup._id}`).click(evt => {
      if (
        $(evt.target).hasClass('remove-chat-group-btn') ||
        $(evt.target).hasClass('flaticon-delete')
      ) {
        return;
      }
      getGroupChat(chatGroup);
    });
  };

  const alreadyFetched = groupId =>
    !!privateChatsList.filter(group => group._id === groupId).length;

  const fetchNextUsers = () =>
    new Promise(resolve => {
      mApp.block('#connectModuleSideBar', {});
      let url = `/api/chat/group/users/search?sort=username&offset=50&index=${userList.length}`;
      if (searchUsersValue) {
        url += `&search=${searchUsersValue}`;
      }
      if (selectedUserType) {
        url += `&type=${selectedUserType}`;
      }
      new Request()
        .get(url, null, true)
        .done(result => {
          const $userListLayout = $('#userListLayout');
          const users = result.data;
          if (users.length === 0) {
            totalUserList = users.length;
          }

          getUser().then(loggedUser => {
            // TODO: Create ejs file
            for (let i = 0; i < users.length; i += 1) {
              const user = users[i];
              if (!alreadyFetched(user._id)) {
                userList.push(user);
                $userListLayout.append(
                  RenderService.EJS('/chat/adapters/user_list_item.ejs', {
                    user,
                    directSellingServiceActive,
                    loggedUser,
                    tenant,
                  }),
                );
                getChatMessagesByUser(user);
              }
            }
            mApp.unblock('#connectModuleSideBar');
            resolve(result);
          });
        })
        .fail(err => {
          console.error(err);
        });
    });

  const fetchNextPrivateChats = () =>
    new Promise(resolve => {
      mApp.block('#connectModuleSideBar', {});
      let url = `/chat-group/table/list?type=individual&index=${privateChatsList.length}`;
      if (searchPrivateChatValue) {
        url += `&search=${searchPrivateChatValue}`;
      }
      new Request()
        .get(url, null, true)
        .done(result => {
          const $privateChatsSideBar = $('#privateChatsSideBar');
          const groups = result.data;
          if (groups.length === 0) {
            totalPrivateChatList = privateChatsList.length;
          }
          for (let i = 0; i < groups.length; i += 1) {
            const group = groups[i];

            if (activeChatGroup && activeChatGroup._id === group._id) {
              activeChatGroup = group;
            }
            if (!alreadyFetched(group._id)) {
              privateChatsList.push(group);
              // eslint-disable-next-line no-loop-func
              const otherUser = group.users.find(u => u._id !== userId);
              $privateChatsSideBar.append(
                RenderService.EJS('/chat/adapters/private_chat_list_item.ejs', {
                  chatGroup: group,
                  otherUser,
                }),
              );
              getChatMessageByChatGroup(group);
            }
          }
          mApp.unblock('#connectModuleSideBar');
          resolve(result);
        })
        .fail(err => {
          console.error(err);
        });
    });

  const initUserList = () => {
    fetchNextUsers().then(result => {
      totalUserList = result.total;
      userItemHeight = $('.user-list-item').outerHeight(true);
      $('#userListLayout').height(userItemHeight * totalPrivateChatList);
    });
  };

  const initPrivateChatList = () => {
    fetchNextPrivateChats().then(result => {
      totalPrivateChatList = result.total;
      privateChatItemHeight = $('.chat-group-item').outerHeight(true);
      $('#privateChatsSideBar').height(
        privateChatItemHeight * totalPrivateChatList,
      );
    });
  };

  const initUserChatGroupList = () => {
    $('#chatGroupSideBar').on('click', '.remove-chat-group-btn', evt => {
      evt.stopPropagation();
      const groupId = $(this).attr('data-group-id');
      connectModuleSidebar.askToRemoveGroup(groupId);
    });
    let url = '/chat-group/table/list?type=group';
    if (searchChatGroupValue) {
      url += `&search=${searchChatGroupValue}`;
    }
    new Request()
      .get(url, null, true)
      .done(result => {
        const groups = result.data;

        for (let i = 0; i < groups.length; i += 1) {
          const group = groups[i];
          if (activeChatGroup && activeChatGroup._id === group._id) {
            activeChatGroup = group;
          }
          $('#chatGroupSideBar').append(
            RenderService.EJS('/chat/adapters/chat_group_list_item.ejs', {
              chatGroup: group,
              userId,
            }),
          );
          getChatMessageByChatGroup(groups[i]);
        }
        mApp.unblock('#connectModuleSideBar');
      })
      .fail(handleError);
  };

  const appendChatMessage = (chatGroup, chatMessage) => {
    if (chatGroup._id === activeChatGroup._id) {
      $('#chatMessagesContent').append(
        renderChatMessage(chatGroup, chatMessage),
      );
    }
  };

  const handleChatMessageForm = () => {
    const input = $('#chatMessageText');

    const text = input.val();
    if (text.length === 0) {
      return;
    }

    SocketClient.sendMessage(activeChatGroup._id, text, result => {
      if (result.success === true) {
        appendChatMessage(activeChatGroup, result.data);
        connectModuleSidebar.moveChatScroll({ onlyOnBottom: true });
        input.val('');
        $(`#${result.data._id}`).hide().fadeIn(300);
      } else {
        Notifications.showNotificationError(
          i18n.__('error'),
          i18n.__(result.error),
        );
      }
    });
  };

  const handleUserListScrollListener = () => {
    const listContainer = document.getElementById('userListWrapper');
    if (userListScroll) {
      userListScroll.destroy();
      userListScroll = null;
    }
    userListScroll = new PerfectScrollbar(listContainer, {
      suppressScrollX: true,
      wheelPropagation: false,
      handlers: ['wheel'],
    });
    listContainer.addEventListener('ps-scroll-down', event => {
      if (totalUserList > userList.length) {
        const errorMargin = userItemHeight * 20;
        const totalHeight = userItemHeight * userList.length;
        const scrollHeight = event.target.scrollTop;
        if (scrollHeight > totalHeight - errorMargin) {
          fetchNextUsers();
        }
      }
    });
  };

  const handlePrivateChatScrollListener = () => {
    const listContainer = document.getElementById('chatListWrapper');
    if (privateChatListScroll) {
      privateChatListScroll.destroy();
      privateChatListScroll = null;
    }
    privateChatListScroll = new PerfectScrollbar(listContainer, {
      suppressScrollX: true,
      wheelPropagation: false,
      handlers: ['wheel'],
    });
    listContainer.addEventListener('ps-scroll-down', event => {
      if (totalPrivateChatList > privateChatsList.length) {
        const errorMargin = privateChatItemHeight * 20;
        const totalHeight = privateChatItemHeight * privateChatsList.length;
        const scrollHeight = event.target.scrollTop;
        if (scrollHeight > totalHeight - errorMargin) {
          fetchNextPrivateChats();
        }
      }
    });
  };

  const handleChatGroupScrollListener = () => {
    if (chatGroupListScroll) {
      chatGroupListScroll.destroy();
      chatGroupListScroll = null;
    }
    chatGroupListScroll = new PerfectScrollbar('#chatGroupListWrapper', {
      suppressScrollX: true,
      wheelPropagation: false,
    });
  };

  const handleConnectModuleSideBar = () => {
    const wrapper = $('#m_quick_sidebar');

    const initConnectSlimScroll = () => {
      const wrapperHeight = wrapper.outerHeight(true);
      $('#userListWrapper').attr('style', `height: ${wrapperHeight - 110}px`);
      if (chatPrivateEnabled) {
        $('#chatListWrapper').attr('style', `height: ${wrapperHeight - 110}px`);
      }
      if (chatGroupsEnabled) {
        $('#chatGroupListWrapper').attr(
          'style',
          `height: ${wrapperHeight - 110}px`,
        );
      }
      $('#chatMessagesWrapper').attr(
        'style',
        `height: ${wrapperHeight - 110}px`,
      );

      handleUserListScrollListener();
      if (chatPrivateEnabled) {
        handlePrivateChatScrollListener();
      }
      if (chatGroupsEnabled) {
        handleChatGroupScrollListener();
      }

      const messagesContainer = document.getElementById('chatMessagesWrapper');
      if (chatMessagesListScroll) {
        chatMessagesListScroll.destroy();
        chatMessagesListScroll = null;
      }
      chatMessagesListScroll = new PerfectScrollbar(messagesContainer, {
        suppressScrollX: true,
        wheelPropagation: false,
      });
      messagesContainer.addEventListener('ps-scroll-up', event => {
        const scrollHeight = event.target.scrollTop;
        const totalHeight = $('#chatMessagesContent').outerHeight(true);
        if (totalMessageList > messages.length && !isFetchingMessages) {
          if (scrollHeight < totalHeight * 0.5) {
            fetchNextMessages();
          }
        } else if (isFetchingMessages) {
          if (scrollHeight < totalHeight * 10) {
            mApp.block('#chatMessageSideBar');
          }
        }
        $('#m_scroll_bottom').show();
      });

      mApp.block('#connectModuleSideBar', {});
    };

    initConnectSlimScroll();

    wrapper.find('.page-quick-sidebar-back-to-list').click(() => {
      $('#connectModuleSideBar').removeClass('is-hidden');
      $('#chatMessageSideBar').addClass('is-hidden');
      SocketClient.leaveChatGroup(activeChatGroup._id);
      activeChatGroup = null;
    });

    wrapper.find('.page-quick-sidebar-edit').click(() => {
      connectModuleSidebar.editGroup(activeChatGroup);
    });

    const handleChatUpload = type => evt => {
      const file = evt.target.files[0];
      const originalName = file.name;
      const { size } = file;
      const nameParts = originalName.split('.');
      const ext = `.${nameParts[nameParts.length - 1]}`;
      const data = new FormData();
      data.append('file', file);

      let url = `/upload/${type}`;
      if (type === 'video') {
        url += '?skipThumbnail=true';
      }
      new Request(_csrf)
        .formMulti('POST', url, data)
        .done(result => {
          const toSocketData = (() => {
            switch (type) {
              case 'image':
                return { image: result.data };
              case 'video':
                return {
                  video: {
                    url: result.data.url,
                    thumb: result.data.thumb,
                    converted: false,
                  },
                };
              case 'file':
              default: {
                const newNameParts = result.data.split('/');
                const newName = newNameParts[newNameParts.length - 1];
                return {
                  file: {
                    url: result.data,
                    name: newName,
                    originalName,
                    ext,
                    size,
                  },
                };
              }
            }
          })();

          SocketClient.sendFile(
            activeChatGroup._id,
            type,
            toSocketData,
            socketResult => {
              if (socketResult.success === true) {
                appendChatMessage(activeChatGroup, socketResult.data);
                connectModuleSidebar.moveChatScroll({ onlyOnBottom: true });
                $(`#chatInput_${type}`).val('');
                $(`#${socketResult.data._id}`).hide().fadeIn(300);
              } else {
                Notifications.showNotificationError(
                  i18n.__('error'),
                  i18n.__(socketResult.error),
                );
              }
            },
          );
        })
        .fail(handleError);
    };

    $('#sendChatMessageButton').click(() => {
      handleChatMessageForm(); // handles quick sidebar's chats
    });

    $('#shareChatImageButton').click(() => {
      $('#chatInput_image').click();
    });

    $('#chatInput_image').change(handleChatUpload('image'));

    $('#shareChatFileButton').click(() => {
      $('#chatInput_file').click();
    });

    $('#chatInput_file').change(handleChatUpload('file'));

    $('#shareChatVideoButton').click(() => {
      $('#chatInput_video').click();
    });

    $('#chatInput_video').change(handleChatUpload('video'));

    $('#chatMessageText').keypress(e => {
      if (e.which === 13) {
        handleChatMessageForm(); // handles quick sidebar's chats
        return false;
      }
      return true;
    });
  };

  const handleScrollToBottom = () => {
    const scrollBottomEl = $('#m_scroll_bottom');
    scrollBottomEl.click(() => {
      connectModuleSidebar.moveChatScroll();
    });
    scrollBottomEl.hide();
  };

  const handleScrollReachedBottom = () => {
    $('#chatMessagesWrapper').scroll(() => {
      if (connectModuleSidebar.isScrollOnBottom('#chatMessagesWrapper')) {
        $('#m_scroll_bottom').hide();
      } else {
        $('#m_scroll_bottom').show();
      }
    });
  };

  connectModuleSidebar.askToRemoveGroup = groupId => {
    $('#removeChatGroup #chatGroupId').val(groupId);
    $('#removeChatGroup').modal('show');
  };

  connectModuleSidebar.removeChatGroup = () => {
    const groupId = $('#removeChatGroup #chatGroupId').val();
    new Request(_csrf)
      .delete(`/chat-group/${groupId}`)
      .done(() => {
        $('#removeChatGroup').modal('hide');
        connectModuleSidebar.reloadChatGroupList();
        Notifications.showNotificationSuccess(
          i18n.__('success'),
          i18n.__('remove_chatGroup_success'),
        );
      })
      .fail(err => {
        $('#removeChatGroup #chatGroupId').val('');
        $('#removeChatGroup').modal('hide');
        handleError(err);
      });
  };

  connectModuleSidebar.onOpenChatSidebar = () => {
    const $sidebar = $('#m_quick_sidebar');
    if (!$sidebar.hasClass('.m-quick-sidebar--on')) {
      $sidebar.addClass('m-quick-sidebar--on');
      const $body = $('body');
      if ($body.find('.m-quick-sidebar-overlay').length === 0) {
        $("<div class='m-quick-sidebar-overlay' />").insertAfter(
          '#m_quick_sidebar',
        );
        $body.find('.m-quick-sidebar-overlay').on('click', function () {
          $(this).remove();
          $sidebar.removeClass('m-quick-sidebar--on');
        });
      }
    }
  };

  connectModuleSidebar.onOpen = () => {
    // Opens chat sidebar by jquery needed in profile
    connectModuleSidebar.onOpenChatSidebar();
    if (!userList.length) {
      initUserList();
      if (chatPrivateEnabled) {
        initPrivateChatList();
      }
      if (chatGroupsEnabled) {
        initUserChatGroupList();
      }
    }
    // if a chat window is open mark it's unread messages as read
    if (!$('#chatMessageSideBar').hasClass('is-hidden')) {
      $('.m-messenger__wrapper').each(() => {
        const isRead = JSON.parse($(this).attr('data-read'));
        if (!isRead) {
          setChatMessageRead($(this).attr('id'));
        }
      });
    }
  };

  /**
   * Use to open a specific chat group
   * Example: Support chat group for opportunities
   * @param chatGroup
   */
  connectModuleSidebar.onOpenSpecificGroup = chatGroup => {
    // Opens chat sidebar by jquery needed in profile
    connectModuleSidebar.onOpenChatSidebar();
    getGroupChat(chatGroup);

    const $sidebar = $('#m_quick_sidebar');
    $sidebar.find('.page-quick-sidebar-back-to-list').click(() => {
      SocketClient.leaveChatGroup(chatGroup._id);
      activeChatGroup = null;

      if ($sidebar.hasClass('m-quick-sidebar--on')) {
        $sidebar.removeClass('m-quick-sidebar--on');
        $('.m-quick-sidebar-overlay').remove();
      }
    });
  };

  connectModuleSidebar.getByUser = target => {
    getUserChat(target);
  };

  connectModuleSidebar.getByGroup = chatGroup => {
    getGroupChat(chatGroup);
  };

  /**
   * Returns true when the scroll is at the bottom or within the threshold
   * @param elementSelector The selector for the scrollable element
   * @param threshold The distance, in pixels, from the bottom that is accepted as bottom
   */
  connectModuleSidebar.isScrollOnBottom = (
    elementSelector,
    { threshold = 100 } = {},
  ) => {
    const wrapper = $(elementSelector);
    if (wrapper && wrapper[0]) {
      return (
        wrapper.scrollTop() + wrapper.innerHeight() + threshold >=
        wrapper[0].scrollHeight
      );
    }
    return false;
  };

  /**
   * Scrolls the chat wrapper to the bottom
   * @param onlyOnBottom if set to true will only scroll if the scroll position is on the bottom of the page
   */
  connectModuleSidebar.moveChatScroll = ({ onlyOnBottom } = {}) => {
    if (
      !onlyOnBottom ||
      connectModuleSidebar.isScrollOnBottom('#chatMessagesWrapper')
    ) {
      // FIXME: Can't user Number.MAX_SAFE_INTEGER because of firefox bug:
      // https://bugzilla.mozilla.org/show_bug.cgi?id=1142742
      document.querySelector('#chatMessagesWrapper').scrollTop = 500000;
      $('#m_scroll_bottom').hide();
    }
  };

  connectModuleSidebar.addMessageToChatGroup = chatMessage => {
    if (chatMessage.group === activeChatGroup._id) {
      appendChatMessage(activeChatGroup, chatMessage);

      // mark message as read if the chat sidebar is open
      if ($('#m_quick_sidebar').hasClass('m-quick-sidebar--on')) {
        setChatMessageRead(chatMessage._id);
      }

      connectModuleSidebar.moveChatScroll({ onlyOnBottom: true });

      if (!connectModuleSidebar.isScrollOnBottom('#chatMessagesWrapper')) {
        $('#m_scroll_bottom').show();
      }

      $(`#${chatMessage._id}`).hide().fadeIn(300);
    }
  };

  connectModuleSidebar.updateMessage = chatMessage => {
    if (chatMessage.group === activeChatGroup._id) {
      const chatEl = $(`#${chatMessage._id}`);
      chatEl.replaceWith(renderChatMessage(activeChatGroup, chatMessage));

      chatEl.hide().fadeIn(300);
    }
  };

  connectModuleSidebar.setBadgeValues = badge => {
    if (badge.chat > 0) {
      $('#badgeChat').show();
    } else {
      $('#badgeChat').hide();
    }
  };

  /** Search for users */
  const handleSearchForUsers = () => {
    const $input = $('#searchUsersText');

    const search = () => {
      searchUsersValue = $input.val();
      connectModuleSidebar.reloadUserList();
    };

    $('#searchUsersButton').click(() => {
      search();
    });

    $input.keyup(event => {
      const keycode = event.keyCode || event.which;
      if (keycode === 13) {
        search();
      }
    });
  };

  /** Search for private chats */
  const handleSearchForPrivateChats = () => {
    const $input = $('#searchPrivateChatText');

    const search = () => {
      searchPrivateChatValue = $input.val();
      connectModuleSidebar.reloadPrivateChatList();
    };

    $('#searchPrivateChatButton').click(() => {
      search();
    });

    $input.keyup(event => {
      const keycode = event.keyCode || event.which;
      if (keycode === 13) {
        search();
      }
    });
  };

  /** Search for chat groups */
  const handleSearchForChatGroups = () => {
    const $input = $('#searchChatGroupsText');

    const search = () => {
      searchChatGroupValue = $input.val();
      connectModuleSidebar.reloadChatGroupList();
    };

    $input.keyup(event => {
      const keycode = event.keyCode || event.which;
      if (keycode === 13) {
        search();
      }
    });
  };

  connectModuleSidebar.reloadUserList = () => {
    mApp.block('#connectModuleSideBar', {});
    $('#userListLayout').html('');
    totalUserList = 0;
    userList = [];
    document.getElementById('userListWrapper').scrollTop = 0;
    initUserList();
  };

  connectModuleSidebar.reloadPrivateChatList = () => {
    if (chatPrivateEnabled) {
      mApp.block('#connectModuleSideBar', {});
      $('#privateChatsSideBar').html('');
      totalPrivateChatList = 0;
      privateChatsList = [];
      document.getElementById('chatListWrapper').scrollTop = 0;
      initPrivateChatList();
    }
  };

  connectModuleSidebar.reloadChatGroupList = () => {
    if (chatGroupsEnabled) {
      mApp.block('#connectModuleSideBar', {});
      $('#chatGroupSideBar').html('');
      document.getElementById('chatGroupListWrapper').scrollTop = 0;
      initUserChatGroupList();
    }
  };

  const initUserSelector = (id, url, width) => {
    const LENGTH = 20;

    const $userSelector = $(id);
    if ($userSelector.data('select2')) {
      $userSelector.val(null).trigger('change');
      $userSelector.select2('destroy');
      $userSelector.html('');
    }
    $userSelector.select2({
      width,
      allowClear: true,
      multiple: true,
      placeholder: i18n.__('user_selector_placeholder'),
      ajax: {
        url,
        data(params) {
          const page = params.page || 1;
          return {
            term: params.term,
            page,
            perpage: LENGTH,
          };
        },
        dataType: 'json',
        delay: 200,
        processResults(res) {
          return {
            results: res.data.map(user => ({
              id: user._id,
              text: user.username,
            })),
            pagination: { more: res.meta.page < res.meta.pages },
          };
        },
      },
    });
    return $userSelector;
  };

  const mountImageInput = initialValue => {
    const container = document.getElementById('imageContainer');
    ReactDOM.unmountComponentAtNode(container);
    ReactDOM.render(
      React.createElement(
        ImageInput,
        {
          t: i18n.__,
          label: i18n.__('image_chat_group'),
          labelClassName: 'col-md-3 col-form-label text-right',
          containerClassName: 'col-md-8',
          handleCrop: false,
          onChange: onImageChange,
          initialValue,
        },
        null,
      ),
      container,
    );
  };

  const clearChatGroupForm = () => {
    $('#addChatGroup .has-success').removeClass('has-success');
    $('#addChatGroup .has-danger').removeClass('has-danger');
    $('#addChatGroup .form-control-feedback').remove();

    $('#addChatGroup #chatGroupId').val('');
    $('#addChatGroup #name').val('');
    $('#addChatGroup #chat-users').val(null).trigger('change');
    $('#addChatGroup #image').val('');
    imageState = null;
    mountImageInput();
    $('a[href="#add-chat-group-info"]').click();
    $('#tabs-container').hide();
    $('#chat-users-container').show();
  };

  const performMemberRequest = (groupId, method, params) => {
    new Request(_csrf)
      [method](`/chat-group/${groupId}/member`, params)
      .done(() => {
        $('#chat-members-table').mDatatable().reload();
      })
      .fail(err => handleError(err));
  };

  const configMemberTable = groupId => {
    const $memberSearch = $('#member-search-input');
    const $table = $('#chat-members-table');

    const config = {
      data: {
        type: 'remote',
        source: {
          read: {
            url: `/chat-group/${groupId}/users`,
            method: 'GET',
          },
        },
        pageSize: 10,
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        saveState: {
          cookie: false,
          webstorage: false,
        },
      },
      layout: {
        theme: 'default',
        class: '',
        scroll: true,
        header: true,
        footer: false,
        height: null,
      },
      sortable: false,
      pagination: true,
      pagingType: 'full_numbers',
      search: {
        nEnter: false,
        delay: 300,
        input: $memberSearch,
      },
      columns: [
        {
          field: 'username',
          title: i18n.__('name'),
          textAlign: 'left',
          width: 400,
          template: row =>
            RenderService.EJS('/chat/adapters/user_name_list.ejs', {
              user: row,
            }),
        },
        {
          field: 'actions',
          title: '',
          textAlign: 'right',
          width: 50,
          template: row =>
            RenderService.EJS('/chat/adapters/user_list_actions.ejs', {
              user: row,
            }),
        },
      ],
    };

    initUserSelector(
      '#member-table-selector',
      `/chat-group/users/search?groupId=${groupId}`,
      '60%',
    );

    $table.on('click', '.user-list-remove', function handler() {
      const memberCount = $('#chat-members-table .m-datatable__body tr').length;
      if (memberCount <= 2) {
        Notifications.showNotificationError(
          i18n.__('error'),
          i18n.__('minimum_chat_group_user'),
        );
      } else {
        const toRemove = $(this).data('user');
        performMemberRequest(groupId, 'delete', { user: toRemove });
      }
    });

    $('.user-list-add').on('click', () => {
      const $selector = $('#member-table-selector');
      const toAdd = $selector.val();
      if (toAdd && toAdd.length > 0) {
        performMemberRequest(groupId, 'put', { users: toAdd });
        $selector.val('').trigger('change');
      }
    });

    return $table.mDatatable(config);
  };

  // endregion

  // region Chat Groups
  connectModuleSidebar.editGroup = group => {
    clearChatGroupForm();
    configMemberTable(group._id);
    $('#tabs-container').show();
    $('#chat-users-container').hide();

    $('#addChatGroup #chatGroupId').val(group._id);
    $('#addChatGroup #name').val(group.name);
    mountImageInput(group.image ? group.image.url : '');
    imageState = group.image;

    $('#addChatGroup .modal-title').text(i18n.__('edit_chat_group'));
    $('#addChatGroup').modal('show');
  };

  connectModuleSidebar.addGroup = () => {
    clearChatGroupForm();
    $('#tabs-container').hide();
    $('#chat-users-container').show();
    $('#addChatGroup .modal-title').text(i18n.__('add_chat_group'));
    $('#addChatGroup').modal('show');
  };

  const configChatGroupForm = () => {
    mountImageInput();
    initUserSelector('#chat-users', '/chat-group/users/search', '100%');

    const [form] = FormValidator.init('#addChatGroupForm', {
      rules: {
        name: {
          required: true,
        },
      },

      messages: {
        // custom messages for radio buttons and checkboxes
        name: {
          required: i18n.__('required_chat_group_name'),
        },
      },

      submitHandler: (f, evt) => {
        evt.preventDefault();
        const userSelector = $('#chat-users:visible');
        let users;
        if (userSelector.length) {
          users = userSelector.val();
          if (users.length < 2) {
            Notifications.showNotificationError(
              i18n.__('error'),
              i18n.__('required_chat_group_user'),
            );
            return;
          }
        }

        handleImageUpload(i18n.__, _csrf, imageState, false).then(image => {
          const params = { name: form.find('input[name=name]').val() };
          if (users) {
            params.users = users;
          }
          if (image) {
            params.image = JSON.stringify(image);
          }

          const groupId = $('#addChatGroup #chatGroupId').val();
          const requestResult = groupId
            ? new Request(_csrf).put(`/chat-group/${groupId}`, params)
            : new Request(_csrf).post('/chat-group', params);
          const message = groupId
            ? 'update_chat_group_success'
            : 'add_chat_group_success';

          requestResult
            .done(() => {
              $('#addChatGroup').modal('hide');
              connectModuleSidebar.reloadChatGroupList();
              Notifications.showNotificationSuccess(
                i18n.__('success'),
                i18n.__(message),
              );
            })
            .fail(handleError);
        });
      },
    });

    $('#addChatGroup #chat-users', form).change(() =>
      form.validate().element($(this)),
    );
  };

  // endregion

  // region User Invitations
  /*
   * User Invitations
   * */
  let userInvitationList = [];
  const clearUserInvitationForm = () => {
    userInvitationList = [];
    $('#userInviteList').html('');
  };

  const getUsersEmailInvitations = () => {
    for (let i = 0; i < userInvitationList.length; i += 1) {
      const id = userInvitationList[i]._id;
      userInvitationList[i].email = $('#userInviteList')
        .find(`#${id}`)
        .find('input[name=email]')
        .val();
      const languageField = $('#userInviteList')
        .find(`#${id}`)
        .find('select[name=language]')
        .val();
      userInvitationList[i].language = languageField.toUpperCase();
      userInvitationList[i].type = $('#userInviteList')
        .find(`#${id}`)
        .find('select[name=type]')
        .val();

      userInvitationList[i].wasInvitedBy = $('#userInviteList')
        .find(`#${id}`)
        .find('select[name=wasInvitedBy]')
        .val();

      userInvitationList[i].phone =
        $('#userInviteList').find(`#${id}`).find('input[name=phone]').val() ||
        '';
    }
    return userInvitationList;
  };

  const configUserInvitationForm = () => {
    const [form, error] = FormValidator.init('#inviteUsersForm', {
      rules: {
        // Add dynamic validation rules for email inputs
        email: {
          required(element) {
            // Only require email if wasInvitedBy is 'email'
            const row = $(element).closest('.row');
            const wasInvitedBy = row.find('select[name=wasInvitedBy]').val();
            return wasInvitedBy === 'email';
          },
          pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        },
        phone: {
          required(element) {
            // Only require phone if wasInvitedBy is 'phone'
            const row = $(element).closest('.row');
            const wasInvitedBy = row.find('select[name=wasInvitedBy]').val();
            return wasInvitedBy === 'phone';
          },
        },
      },
      messages: {},
      submitHandler: (f, evt) => {
        evt.preventDefault();
        error.hide();
        const emails = getUsersEmailInvitations();

        const $submitBtnSelector = $('#chatInviteUserSubmit');
        $submitBtnSelector
          .addClass('m-loader m-loader--right m-loader--light')
          .attr('disabled', true);

        const errors = emails?.filter(
          email =>
            (email.wasInvitedBy === 'phone' && !email.phone) ||
            (email?.wasInvitedBy === 'email' && !email.email),
        );

        if (errors?.length > 0) {
          Notifications.showNotificationError(
            i18n.__('error'),
            i18n.__('invite.users.validation.error', errors.length),
          );
          $submitBtnSelector
            .removeClass('m-loader m-loader--right m-loader--light')
            .attr('disabled', false);
          return;
        }

        new Request(_csrf)
          .post('/user/invite', {
            emails: emails.map(u => ({
              ...u,
              email: u.wasInvitedBy === 'email' ? u.email : null,
              phone: u.wasInvitedBy === 'phone' ? `${u.phone}` : null,
            })),
          })
          .done(({ data: invitedUsers }) => {
            if (invitedUsers.errors.length > 0) {
              console.log('invitedUsers.errors', invitedUsers.errors);
              clearUserInvitationForm();
              let err;
              invitedUsers.errors.map(item => {
                const { user } = item;
                err = item.error.key;
                connectModuleSidebar.addInputUserEmailInvitation(
                  user.email,
                  item.error.key,
                );
                return user;
              });
              Notifications.showErrorFromRequest(err, i18n.__(err));
            } else {
              $('#addChatUser').modal('hide');
              connectModuleSidebar.reloadChatGroupList();
              Notifications.showNotificationSuccess(
                i18n.__('success'),
                i18n.__('invite_users_success'),
              );
            }

            $submitBtnSelector
              .removeClass('m-loader m-loader--right m-loader--light')
              .attr('disabled', false);
          })
          .fail(err => {
            $submitBtnSelector
              .removeClass('m-loader m-loader--right m-loader--light')
              .attr('disabled', false);
            handleError(err);
          });
      },
    });
  };

  connectModuleSidebar.showUserInvitationPopup = () => {
    clearUserInvitationForm();
    $('#addChatUser').modal('show');
    connectModuleSidebar.addInputUserEmailInvitation(
      null,
      null,
      null,
      null,
      null,
    );
  };

  connectModuleSidebar.addInputUserEmailInvitation = (
    email,
    errorKey,
    language,
    phone,
    wasInvitedBy,
  ) => {
    const user = {
      _id: uuid(),
      email: null,
      language: null,
      phone: null,
      wasInvitedBy: 'email',
    };
    if (email) {
      user.email = email;
    }
    if (phone) {
      user.phone = phone;
    }
    if (wasInvitedBy) {
      user.wasInvitedBy = wasInvitedBy;
    }
    if (language) {
      user.language = language.toUpperCase();
    }

    $('#userInviteList').append(
      RenderService.EJS('/components/invite_user.ejs', {
        user,
        errorKey,
        orgLanguages,
        userTypes,
        usersCanChooseTheirType,
      }),
    );
    userInvitationList.push(user);

    if (user.wasInvitedBy === 'email') {
      $(`#${user._id}`).find('.input-phone').hide();
    } else {
      $(`#${user._id}`).find('.input-email').hide();
    }
  };

  connectModuleSidebar.removeInputUserEmailInvitation = id => {
    _.remove(userInvitationList, item => item._id === id);
    $(`#${id}`).hide('normal');
  };

  connectModuleSidebar.validateInputUserEmailInvitation = () => {
    let isValidated = true;
    for (let i = 0; i < userInvitationList.length; i += 1) {
      const id = userInvitationList[i]._id;
      userList[i].email = $('#userInviteList')
        .find(`#${id}`)
        .find('input[name=email]')
        .val();

      if (!$(`#${id}`).find('input[name=email]').valid()) {
        isValidated = false;
      }
      if (!$(`#${id}`).find('select[name=role]').valid()) {
        isValidated = false;
      }
    }

    return isValidated;
  };
  // endregion

  /*
   * Initialization
   * */
  const initForms = () => {
    if (directSellingServiceActive) {
      $('#inviteUserButton').click(
        connectModuleSidebar.showUserInvitationPopup,
      );
    }
    $('#userTypeFilter').on('change', connectModuleSidebar.onUserTypeChange);
    $('#addChatGroupButton').click(connectModuleSidebar.addGroup);
    configUserInvitationForm();
    configChatGroupForm();
  };

  const initBadge = () => {
    new Request()
      .get('/chat-group/badge', null, true)
      .done(result => connectModuleSidebar.setBadgeValues(result.data))
      .fail(handleError);
  };

  connectModuleSidebar.init = (
    user,
    _csrfToken,
    userChatEnabled,
    groupChatEnabled,
    directSellingActive,
    languages,
    tenantParam,
    organizationParam,
  ) => {
    userId = user;
    _csrf = _csrfToken;
    orgLanguages = languages;

    chatPrivateEnabled = userChatEnabled;
    chatGroupsEnabled = groupChatEnabled;
    directSellingServiceActive = directSellingActive;
    tenant = tenantParam;
    organization = organizationParam;
    usersCanChooseTheirType = tenantParam?.settings?.usersCanChooseTheirType;
    const orgUserTypes = organization.userTypes;
    // Get language from cookie
    const currentLang = document.cookie
      .split('; ')
      .find(row => row.startsWith('localLanguage='))
      ?.split('=')[1];
    userTypes = [
      {
        id: 'collaborator',
        text:
          orgUserTypes?.collaborator[currentLang] ||
          i18n.__('user_type_collaborator'),
      },
      {
        id: 'customer',
        text:
          orgUserTypes?.customer[currentLang] || i18n.__('user_type_customer'),
      },
      // Only distributors and customers are available (https://bravon.atlassian.net/browse/BRAVON-5012)
      // {
      //   id: 'lead',
      //   text: orgUserTypes?.lead[currentLang] || i18n.__('user_type_lead'),
      // },
      // {
      //   id: 'recommendation',
      //   text:
      //     orgUserTypes?.recommendation[currentLang] ||
      //     i18n.__('user_type_recommendation'),
      // },
      // {
      //   id: 'visitor',
      //   text:
      //     orgUserTypes?.visitor[currentLang] || i18n.__('user_type_visitor'),
      // },
    ];

    if (!chatPrivateEnabled) {
      $('a[href="#chatGroupListWrapper"]').click();
    }

    handleConnectModuleSideBar();
    handleSearchForUsers();
    handleSearchForPrivateChats();
    handleSearchForChatGroups();

    handleScrollToBottom();
    handleScrollReachedBottom();
    initForms();
    initBadge();

    SocketClient.on('CHAT_MESSAGE', connectModuleSidebar.addMessageToChatGroup);
    SocketClient.on('BADGE', connectModuleSidebar.setBadgeValues);
    SocketClient.on('CHAT_VIDEO_READY', connectModuleSidebar.updateMessage);

    window.ChatService = connectModuleSidebar;
  };

  connectModuleSidebar.changeWasInvitedBy = (select, userId) => {
    const $row = $(select).closest('.row');
    const invitedBy = select.value;

    if (invitedBy === 'email') {
      $row.find('.input-email').show();
      $row.find('.input-phone').hide();
    } else {
      $row.find('.input-email').hide();
      $row.find('.input-phone').show();
    }
  };

  return connectModuleSidebar;
})();
